import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsRefundIdSchema = z.string().brand('refund-id')
export type UbsRefundId = ZodInfer<typeof UbsRefundIdSchema>

export const UbsRefundId = (value: string): UbsRefundId =>
  UbsRefundIdSchema.parse(value)
